var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmtpIcon = function SvgSmtpIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12.593,
    viewBox: "0 0 16 12.593",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.631-760.136a1.5,1.5,0,0,1-1.1-.454,1.5,1.5,0,0,1-.454-1.1v-9.487a1.5,1.5,0,0,1,.454-1.1,1.5,1.5,0,0,1,1.1-.454h12.895a1.5,1.5,0,0,1,1.1.454,1.5,1.5,0,0,1,.454,1.1v9.487a1.5,1.5,0,0,1-.454,1.1,1.5,1.5,0,0,1-1.1.454ZM122.788-770.2l-6.3,4.025q-.1.048-.193.091a.535.535,0,0,1-.221.043.6.6,0,0,1-.221-.038,1.122,1.122,0,0,1-.191-.1l-6.3-4.024v8.509a.258.258,0,0,0,.074.19.257.257,0,0,0,.19.074h12.891a.257.257,0,0,0,.19-.074.258.258,0,0,0,.074-.19Zm-6.71,2.967,6.6-4.207H109.5Zm-6.71-2.967v0Z",
    transform: "translate(-108.078 772.729)",
    fill: "var(--hyperlink )"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmtpIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smtpIcon.86b83497.svg";
export { ForwardRef as ReactComponent };